/**
 * Card Carousel: centre-focused Swiper, advanced by the visitor only — no
 * autoplay. No pagination either; the active slide is signalled by the card
 * growing (see section-card-carousel.css).
 * Swiper itself is loaded globally in layout/theme.liquid.
 */
(function () {
  var SELECTOR = '[data-card-carousel]';

  function init(root) {
    if (typeof Swiper === 'undefined') return;

    var el = root.querySelector('.card-carousel__swiper');
    if (!el) return;

    // Re-init safely if the theme editor reloads the section.
    if (root._cardCarousel) {
      root._cardCarousel.destroy(true, true);
      root._cardCarousel = null;
    }

    var count = parseInt(root.getAttribute('data-slide-count'), 10) || 0;
    var canLoop = count > 3;

    var options = {
      slidesPerView: 'auto',
      centeredSlides: true,
      spaceBetween: 8,
      speed: 600,
      grabCursor: true,
      watchSlidesProgress: true,
      /* Desktop fits three slides at once, so looping needs MORE than three cards
       * to have anything spare to wrap around behind the active one. With exactly
       * three, Swiper cannot fill the left, clamps the track, and the focused card
       * ends up at one end. Below the threshold, run as a static centred row. */
      loop: canLoop,
      /* Headroom for slidesPerView: 'auto' to measure a full track either side.
       * Asking for a whole extra set makes Swiper shuffle more slides than it has
       * and land the active one off-centre. */
      loopAdditionalSlides: 2,
      /* Swiper 12 pads uneven loop groups with blank slides by default, which
       * shows up as an empty space beside the focused card. */
      loopAddBlankSlides: false,
    };

    /* Either way, open on the second card so there is a real card to its left and
     * right on first paint. Without a loop that is just the initial index; with a
     * loop it has to go through slideToLoop below, because initialSlide fights the
     * slide shuffling loop mode does on init. */
    if (!canLoop) options.initialSlide = count > 2 ? 1 : 0;

    var swiper = new Swiper(el, options);
    root._cardCarousel = swiper;

    if (canLoop) swiper.slideToLoop(1, 0, false);
  }

  function initAll(scope) {
    (scope || document).querySelectorAll(SELECTOR).forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll();
    });
  } else {
    initAll();
  }

  /* Theme editor: the deferred script does not re-run when a section reloads,
   * so mount any newly injected instance. */
  document.addEventListener('shopify:section:load', function (event) {
    if (event.target) initAll(event.target);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    var root = event.target && event.target.querySelector(SELECTOR);
    if (root && root._cardCarousel) {
      root._cardCarousel.destroy(true, true);
      root._cardCarousel = null;
    }
  });
})();
